const $ = require('jquery')
const Backbone = require('backbone')

require('tpl')
const listElementBottomBarTpl = require('../Block/list_element_bottom_bar.html.twig')
const listElementUnfinishedTpl = require('../Block/list_element_unfinished.html.twig')

module.exports = Backbone.View.extend({
  initialize() {
    this.listenTo(this.model, 'change', this.updateUnfinished)
    this.render()
  },

  render() {
    this.setElement(listElementBottomBarTpl({ game: this.model.toJSON() }))
  },

  updateUnfinished() {
    if (this.model.get('unfinished')) {
      if (!this.unfinished) {
        this.unfinished = this.$el.find('.unfinished')
        if (!this.unfinished.length) {
          this.unfinished = $(listElementUnfinishedTpl({ game: this.model.toJSON() }))

          this.$el.append(this.unfinished)
        }
      }
      this.unfinished.show()
    } else if (this.unfinished) {
      this.unfinished.hide()
    }
  },
})
